import React from 'react';
import { Card, Form, Input, Button, Typography, message, Row, Col } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext.tsx';
import { authAPI } from '../services/api.ts';
import { ChangePasswordData } from '../types.ts';

const { Title } = Typography;

const Profile: React.FC = () => {
  const { user } = useAuth();
  const [passwordForm] = Form.useForm();

  const handlePasswordChange = async (values: ChangePasswordData) => {
    try {
      const result = await authAPI.changePassword(values);
      // Il cambio password invalida i token precedenti: si usa subito quello nuovo
      if (result?.access_token) {
        localStorage.setItem('token', result.access_token);
      }
      message.success('Password cambiata con successo');
      passwordForm.resetFields();
    } catch (error: any) {
      const errorMessage = error.response?.data?.detail || 'Errore nel cambio password';
      message.error(errorMessage);
    }
  };

  return (
    <div>
      <Title level={2}>Profilo Utente</Title>
      
      <Row gutter={[24, 24]}>
        <Col xs={24} lg={12}>
          <Card title="Informazioni Profilo" icon={<UserOutlined />}>
            <div style={{ marginBottom: 16 }}>
              <strong>Username:</strong> {user?.username}
            </div>
            <div style={{ marginBottom: 16 }}>
              <strong>Email:</strong> {user?.email || 'Non specificata'}
            </div>
            <div>
              <strong>ID:</strong> {user?.id}
            </div>
          </Card>
        </Col>
        
        <Col xs={24} lg={12}>
          <Card title="Cambia Password" icon={<LockOutlined />}>
            <Form
              form={passwordForm}
              layout="vertical"
              onFinish={handlePasswordChange}
            >
              <Form.Item
                name="current_password"
                label="Password Attuale"
                rules={[{ required: true, message: 'Inserire password attuale' }]}
              >
                <Input.Password />
              </Form.Item>
              
              <Form.Item
                name="new_password"
                label="Nuova Password"
                rules={[
                  { required: true, message: 'Inserire nuova password' },
                  { min: 10, message: 'La password deve avere almeno 10 caratteri' },
                  { pattern: /^(?=.*[A-Za-z])(?=.*\d).+$/, message: 'La password deve contenere almeno una lettera e una cifra' }
                ]}
              >
                <Input.Password />
              </Form.Item>
              
              <Form.Item
                name="confirm_password"
                label="Conferma Nuova Password"
                dependencies={['new_password']}
                rules={[
                  { required: true, message: 'Confermare la nuova password' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('new_password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Le password non coincidono'));
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>
              
              <Form.Item>
                <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
                  Cambia Password
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Profile;
